import CrudRepository from './CrudRepository'
export default class CodeResendRepository extends CrudRepository {
  constructor () {
    super('api/users/resendCode')
  }
}
